import styled from "styled-components";

const EditTagStyles = styled.div``;
export default EditTagStyles;



// WEBPACK FOOTER //
// ./src/Components/EditTag/EditTagWr.js